/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1DepositAdvanceEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PORTFOLIO_V1_DEPOSIT_ADVANCE_EVENT_ENTITY_NAME = 'ixc.portfolio.v1.DepositAdvanceEvent';
export const ixcPortfolioV1DepositAdvanceEventEntity = new schema.Entity<IxcPortfolioV1DepositAdvanceEvent>(IXC_PORTFOLIO_V1_DEPOSIT_ADVANCE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcPortfolioV1DepositAdvanceEvent) => `${entity.metadata?.eventId}` });

